"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epics = _interopRequireDefault(require("settings-ui-sdk/BccEmail/epics"));

var _epics2 = _interopRequireDefault(require("settings-ui-sdk/CanSpamSettings/epics"));

var _epics3 = require("settings-ui-sdk/DesignTemplates/epics");

var _epics4 = require("settings-ui-sdk/DoiPages/epics");

var _epics5 = _interopRequireDefault(require("settings-ui-sdk/DoiSettings/epics"));

var _epics6 = _interopRequireDefault(require("settings-ui-sdk/LandingPages/epics"));

var _epics7 = _interopRequireDefault(require("settings-ui-sdk/SmtpTokens/epics"));

var _epics8 = _interopRequireDefault(require("settings-ui-sdk/SubscriptionDefinitions/epics"));

var _epics9 = require("settings-ui-sdk/SubscriptionEmails/epics");

var _rssLocaleEpics = require("./rssLocaleEpics");

var _saveChangesEpic = _interopRequireDefault(require("./saveChangesEpic"));

var _createFooterEpics = _interopRequireDefault(require("./staging/createFooterEpics"));

var _saveDefaultProperties = _interopRequireDefault(require("./saveDefaultProperties"));

var _default = (0, _reduxObservable.combineEpics)(_epics4.fetchDoiPages, _epics9.fetchOptinSubscriptionEmail, _epics9.fetchOptinFollowupSubscriptionEmail, _epics9.fetchResubscribeSubscriptionEmail, _epics3.fetchSubscriptionTemplates, _rssLocaleEpics.maybeFetchDateTimeFormatOptions, _saveChangesEpic.default, _epics.default, _epics2.default, _createFooterEpics.default, _epics5.default, _epics6.default, _epics7.default, _epics8.default, _saveDefaultProperties.default);

exports.default = _default;
module.exports = exports.default;